import Keycloak from 'keycloak-js';

const keycloakConfig = {
  url: process.env.VUE_APP_KEYCLOAK_URL,
  realm: process.env.VUE_APP_KEYCLOAK_REALM,
  clientId: process.env.VUE_APP_KEYCLOAK_CLIENT_ID,
};

export const keycloakPlugin = new Keycloak(keycloakConfig);

keycloakPlugin.onTokenExpired = () => {
  keycloakPlugin
    .updateToken(5)
    .then((refreshed) => {
      if (!refreshed)
        keycloakPlugin.logout()
    })
    .catch(() => {
      console.error('Failed to refresh token');
      keycloakPlugin.logout()
    });
}